import { MaybeRefOrGetter, toValue } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'
import { ComponentType } from '@/configuration/component/component-types'

export const useReportNumbersQuery = (componentSid: MaybeRefOrGetter<string>, componentType: MaybeRefOrGetter<ComponentType>) => {
    return useQuery({
        queryKey: ['transformers', componentSid, 'reportNumbers'],
        queryFn: async ({ signal }) => {
            const {
                data: { result },
            } = await hcaClientFactory.commentsApi.listReportNumbers(
                toValue(componentSid as string),
                toValue(componentType as ComponentType),
                undefined,
                undefined,
                undefined,
                { signal },
            )
            return result
        },
    })
}
